import React from 'react'

export default ({ dataDgId } = {}) => (
  <div className="text-center">
    <span className="mr-3">TEL：0120-507-765</span>
    <span>メール：</span>
    <a href="mailto:tb-customer-success@hacobell.co.jp" data-dg-id={dataDgId}>
      tb-customer-success@hacobell.co.jp
    </a>
  </div>
)
